import { SxProps, Theme, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

type SectionLabelProps = {
    sx?: SxProps<Theme>;
} & (
    | {
          /** Message id of the label text. */
          id: string;
          children?: never;
      }
    | {
          /** Already resolved label text. */
          children: ReactNode;
          id?: never;
      }
);

/**
 * The uppercase eyebrow label that introduces a section in panels,
 * dialogs and lists. The style is fixed so sections cannot drift apart;
 * only spacing is left to the caller.
 */
export default function SectionLabel({ sx, ...label }: SectionLabelProps) {
    return (
        <Typography
            variant="overline"
            component="p"
            fontSize={10}
            fontWeight={600}
            lineHeight={1.5}
            textTransform="uppercase"
            letterSpacing={0.5}
            color="text.secondary"
            sx={sx}
        >
            {label.id !== undefined ? (
                <FormattedMessage id={label.id} />
            ) : (
                label.children
            )}
        </Typography>
    );
}
